import React from 'react';
import { Link } from 'react-router-dom';
import Loader from '../../../components/Loader';
import { useUsers } from '../context/UsersContext';
import UserStatusBadge from './UserStatusBadge';
export default function UserManagementTable() {
  const { visibleUsers, filteredCount, search, setSearch, status, setStatus, loading, error,
    canManage, reload, page, setPage, totalPages } = useUsers();
  return <section className="m-6 overflow-hidden rounded-xl border border-slate-100 bg-white shadow-sm">
    <div className="flex flex-col gap-4 border-b border-slate-100 p-5 xl:flex-row xl:items-center xl:justify-between">
      <h2 className="font-bold text-slate-900">Employee Directory</h2>
      <div className="flex flex-col gap-3 sm:flex-row">
        <input aria-label="Search users" value={search} onChange={event => setSearch(event.target.value)}
          placeholder="Search name, ID, email or role" type="search" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm sm:w-72" />
        <select aria-label="Filter users by status" value={status} onChange={event => setStatus(event.target.value)} className="rounded-lg border border-slate-200 px-3 py-2 text-sm">
          <option value="">All statuses</option><option value="ACTIVE">Active</option><option value="INACTIVE">Inactive</option>
        </select>
      </div>
    </div>
    {loading ? <Loader type="table" columns={5} /> : error ?
      <div role="alert" className="p-6 text-sm text-red-600">{error}<button type="button" onClick={reload} className="ml-3 font-semibold underline">Retry</button></div> : <>
      <div className="overflow-x-auto"><table className="w-full text-left text-sm">
        <thead className="border-b border-slate-100 bg-slate-50 text-xs text-slate-500"><tr>
          {['User', 'Email', 'Role', 'Status', 'Actions'].map(label => <th key={label} scope="col" className="whitespace-nowrap px-5 py-3 font-semibold">{label}</th>)}
        </tr></thead>
        <tbody className="divide-y divide-slate-100">
          {visibleUsers.map(user => <tr key={user.id} className="hover:bg-slate-50/70">
            <td className="px-5 py-4"><Link to={'/users/' + user.id} className="font-semibold text-slate-900 hover:text-indigo-600">{user.fullName}</Link>
              <p className="mt-1 text-xs text-slate-400">{user.employeeId || 'No employee ID'}</p></td>
            <td className="px-5 py-4 text-slate-600">{user.email}</td>
            <td className="px-5 py-4 text-slate-600">{user.role?.name || 'Unassigned'}</td>
            <td className="px-5 py-4"><UserStatusBadge status={user.status} /></td>
            <td className="whitespace-nowrap px-5 py-4"><div className="flex items-center gap-4">
              <Link to={'/users/' + user.id} aria-label={'View ' + user.fullName} className="font-semibold text-indigo-600 hover:underline">View</Link>
              {canManage && <Link to={'/users/' + user.id + '/edit'} aria-label={'Edit ' + user.fullName} className="font-semibold text-slate-600 hover:underline">Edit</Link>}
            </div></td>
          </tr>)}
          {!visibleUsers.length && <tr><td colSpan={5} className="px-5 py-12 text-center text-slate-500">{search || status ? 'No users match your filters.' : 'No users have been added yet.'}</td></tr>}
        </tbody>
      </table></div>
      <div className="flex flex-wrap items-center justify-between gap-3 border-t border-slate-100 p-4 text-sm text-slate-500">
        <p>{filteredCount} {filteredCount === 1 ? 'user' : 'users'} · Page {page} of {totalPages}</p>
        <div className="flex gap-2"><button type="button" disabled={page === 1} onClick={() => setPage(page - 1)} className="rounded-lg border px-3 py-1.5 disabled:opacity-40">Previous</button>
          <button type="button" disabled={page === totalPages} onClick={() => setPage(page + 1)} className="rounded-lg border px-3 py-1.5 disabled:opacity-40">Next</button></div>
      </div>
    </>}
  </section>;
}
